
import {
  computed,
  defineComponent,
  onMounted,
  onUnmounted,
  ref,
  toRefs,
  watch,
} from "vue";
import { useMessengerHeader } from "@/composables/messengerHeader";
import { closeDialog } from "vue3-promise-dialog";
import { useWidgetConfig } from "@/composables/widgetConfig";
import { WidgetConfigurationChannelInfo } from "@/types/inboundWebhookPayload";
import { useConversation } from "@/composables/conversation";
import { getHumanChannel } from "@/util/formatting";
import { showTransferConversationDestinationDialog } from "@/dialogs/TransferConversationDialog";
import Button from "@/components/Button.vue";
import { useI18n } from "vue-i18n";

export type TransferChannelOption = {
  channel: WidgetConfigurationChannelInfo["channel"];
  suggestionAddress?: string;
  channelDescription: string;
};

export default defineComponent({
  name: "TransferConversationModal",
  components: {
    Button,
  },
  props: {},
  setup(props) {
    const { height: headerHeight, setBackAction } = useMessengerHeader();
    const { visitorInfo, transferChannelOptions } = useConversation();
    const { t } = useI18n();

    const returnValue = () => true;

    const containerStyle = computed(
      () =>
        `top: ${headerHeight.value}px; height: calc(100% - ${headerHeight.value}px)`
    );

    const requestDestination = (option: TransferChannelOption) => {
      closeDialog();
      showTransferConversationDestinationDialog(option);
    };

    onMounted(() => {
      setBackAction(() => closeDialog(null));
    });

    onUnmounted(() => {
      setBackAction(null);
    });

    return {
      returnValue,
      headerHeight,
      containerStyle,
      transferChannelOptions,
      requestDestination,
      visitorInfo,
      t,
    };
  },
});
